var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(field,index){return _c(field.fieldType,_vm._b({key:index,tag:"component"},'component',field,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }